import { environment } from '@environments/environment';

export const GET_COLORS_FILTER_QUERY = (langcode: string) => ({
  query: '_search',
  index: environment.integrations?.fournierWebservice?.index_models ?? '',
  body: {
    size: 0,
    query: {
      bool: {
        filter: [
          {
            term: {
              search_api_language: langcode,
            },
          },
        ],
      },
    },
    aggs: {
      visuels: {
        nested: {
          path: 'field_visuels_principaux',
        },
        aggs: {
          noms_de_filtres: {
            terms: {
              field: 'field_visuels_principaux.filters.name.keyword',
              size: 100,
              order: { _key: 'asc' },
            },
          },
        },
      },
    },
  },
});
